import * as t from './actionTypes';

const initialState = {
  thirdPartyIntegrations: [],
};

const thirdPartyIntegrationsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case t.FETCH_INTEGRATIONS_RESPONSE: {
      return {
        ...state,
        thirdPartyIntegrations: action.integrations,
      };
    }

    case t.REMOVE_INTEGRATION_RESPONSE: {
      return {
        ...state,
        thirdPartyIntegrations: state.thirdPartyIntegrations.filter(
          (i) => i.id !== action.integrationId,
        ),
      };
    }

    default: {
      return state;
    }
  }
};

export default thirdPartyIntegrationsReducer;
